import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api.js'; // ← axios ラッパーなど
import {
  Dialog, DialogTitle, DialogContent, Typography, Box, Container, Button, TextField
} from '@mui/material';
import Header from './components/Header.jsx';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const ITEMS_PER_PAGE = 10;

const formLabels = {
  moving_plan: '搬入出計画書',
  exhibitor_permit: '出展者証発行申請書',
  catchphrase: 'キャッチフレーズ申請書',
  booth_manager: '小間責任者登録',
  electricity_usage: '電気使用申請書',
  lease_furniture: 'リース備品申請書',
  internet: 'インターネット回線申請書',
  pc_rental: 'PCレンタル申請書',
  package_plan: 'パッケージプラン申請書',
  goods_sale: '物販申請書',
  food_sale: '飲食物販売申請書',
  food_safety: '食品衛生申請書',
};

const normalizeBoothNumber = (value) =>
  (value ?? '').toString().replace(/[０-９]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  );


const FormHistoryTable = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await api.get("/api/host-correction-logs");
      setLogs(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [boothSearch, setBoothSearch] = useState('');
  const [showFormMenu, setShowFormMenu] = useState(false); 
  const navigate = useNavigate();
  const filteredLogs = logs.filter((log) =>
    normalizeBoothNumber(log.booth_number).includes(normalizeBoothNumber(boothSearch))
  );
  const totalPages = Math.max(1, Math.ceil(filteredLogs.length / ITEMS_PER_PAGE));
  const paginatedList = filteredLogs.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
  const [selectedLog, setSelectedLog] = useState(null);
  const [open, setOpen] = useState(false);
  const getPreview = (text) => {
    if (!text) return "";
    return text.length > 40 ? text.slice(0, 40) + "..." : text;
  };

  const handlePrev = () => setPage((prev) => Math.max(1, prev - 1));
  const handleNext = () => setPage((prev) => Math.min(totalPages, prev + 1));

  useEffect(() => {
    setPage(1);
  }, [boothSearch]);

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
        <Header
          title="メッセナゴヤ 申請履歴"
        />
        <Container sx={{ mt: 5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* 左メニュー */}
            <Box sx={{ width: '15%', pr: 2, borderRight: '1px solid #ccc' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box className="menu-item" onClick={() => navigate('/host-dashboard')}>
                  申請状況
                </Box>
                <Box
                  className="menu-group"
                  id="hover-block"
                  onMouseEnter={() => {}}
                  onMouseLeave={() => {}}
                >
                  <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                    会社情報
                  </Box>
                    {showFormMenu && (
                      <Box className="hover-menu">
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center' }}
                          className='form-button'
                          onClick={() => navigate('/exhibitor-info')}
                        >
                          出展者
                        </Typography>
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center' }}
                          className='form-button'
                          onClick={() => navigate('/contractor-info')}
                        >
                          協力会社
                        </Typography>
                      </Box>
                    )}
                </Box>
                <Box className="menu-item" onClick={() => navigate('/create-mail')}>
                  メール作成
                </Box>
                <Box className="menu-item" onClick={() => navigate('/create-notice')}>
                  お知らせ作成
                </Box>
                <Box className="menu-item" onClick={() => navigate('/form-history')}>
                  再提出ログ確認
                </Box>
              </Box>
              <BackButton />
            </Box>

            {/* メインコンテンツ（右） */}
            <Box>
              <table>
                <thead>
                  <tr>
                    <th style={{borderRight: '1px solid #000', padding: '0 15px'}}>会社名</th>
                    <th style={{borderRight: '1px solid #000', padding: '0 15px'}}>小間番号</th>
                    <th style={{borderRight: '1px solid #000', padding: '0 15px'}}>届出名</th>
                    <th style={{borderRight: '1px solid #000', padding: '0 15px'}}>送信内容</th>
                    <th>日時</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedList.map((log) => (
                    <tr key={log.correction_id}>
                      <td style={{borderRight: '1px solid #000', padding: '0 15px'}}>{log.company_name}</td>
                      <td style={{borderRight: '1px solid #000', padding: '0 15px'}}>{log.booth_number}</td>
                      <td style={{borderRight: '1px solid #000', padding: '0 15px'}}>{log.form_name}</td>
                      <td
                        style={{ cursor: "pointer", color: "#0071bc", borderRight: '1px solid #000', padding: '0 15px' }}
                        onClick={() => {
                          setSelectedLog(log);
                          setOpen(true);
                        }}
                      >
                        {getPreview(log.body)}
                      </td>
                      <td>{new Date(log.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TextField
                size="small"
                label="小間番号検索"
                value={boothSearch}
                onChange={(e) => setBoothSearch(e.target.value)}
              />
              <Box display="flex" justifyContent="center" alignItems="center" mt={2} gap={2}>
                  <Button variant="outlined" onClick={handlePrev} disabled={page === 1}>前へ</Button>
                  <Typography>{page} / {totalPages}</Typography>
                  <Button variant="outlined" onClick={handleNext} disabled={page === totalPages}>次へ</Button>
              </Box>
              <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth sx={{position: 'relative'}}>
                <IconButton
                  onClick={() => setOpen(false)}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogTitle>メール本文</DialogTitle>
                <DialogContent>
                  <Typography style={{ whiteSpace: "pre-wrap" }}>
                    {selectedLog?.body}
                  </Typography>
                </DialogContent>
              </Dialog>
            </Box>
        </Box>
      </Container>
      <footer>
        <Typography>
            © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
      </footer>
    </div>
  );
};

export default FormHistoryTable;
